import api from './client';

// ─── Auth ────────────────────────────────────────────────
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  changePassword: (current_password, new_password) =>
    api.post('/auth/change-password', { current_password, new_password }),
};

// ─── Dashboard ───────────────────────────────────────────
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
};

// ─── Firmalar ────────────────────────────────────────────
export const firmaAPI = {
  list: (params) => api.get('/firmalar', { params }),
  get: (id) => api.get(`/firmalar/${id}`),
  create: (data) => api.post('/firmalar', data),
  update: (id, data) => api.put(`/firmalar/${id}`, data),
  delete: (id) => api.delete(`/firmalar/${id}`),
  bulkDelete: (ids) => api.delete('/firmalar', { params: { ids: ids.join(',') } }),
  bulkImport: (items) => api.post('/firmalar/import/bulk', { items }),
  exportCSV: (params) => api.get('/firmalar/export/csv', {
    params,
    responseType: 'blob',
  }),
};

// ─── Kurumlar ────────────────────────────────────────────
export const kurumAPI = {
  list: () => api.get('/kurumlar'),
  create: (data) => api.post('/kurumlar', data),
  update: (id, data) => api.put(`/kurumlar/${id}`, data),
  delete: (id) => api.delete(`/kurumlar/${id}`),
};

// ─── İlçe/OSB ────────────────────────────────────────────
export const ilceAPI = {
  list: () => api.get('/ilce-osb'),
  create: (data) => api.post('/ilce-osb', data),
  delete: (id) => api.delete(`/ilce-osb/${id}`),
};

// ─── Ayarlar ─────────────────────────────────────────────
export const ayarAPI = {
  list: () => api.get('/ayarlar'),
  updateMultiple: (data) => api.put('/ayarlar', data),
  update: (key, value) => api.put(`/ayarlar/${key}`, { value }),
};

// ─── Audit Log ───────────────────────────────────────────
export const auditAPI = {
  list: (params) => api.get('/audit-log', { params }),
};
